import type ModbusRTU from 'modbus-serial';

const modbusSerial = (): ModbusRTU => window?.nodeModules?.modbusSerial;

export default modbusSerial;
